// Gatsby Browser API
exports.onInitialClientRender = () => {
  const elems = document.querySelectorAll('.no-js')
  if (elems && elems.length) {
    elems.forEach((el) => {
      el.classList.remove('no-js')
    })
  }
}
